import { memo } from 'react';

import { CheckoutConfirmationResponseType } from 'src/models/Checkout/Confirmation';
import { CheckoutConfirmationTableLayout } from 'src/pages/Checkout/components/common/TableLayout';
import { commonFormatCurrencyWithType } from 'src/utils/currency';
import { useTHelper } from 'src/utils/i18n';
import { UiOuterLink } from 'src/components/UI/OuterLink';

type Props = {
  model: CheckoutConfirmationResponseType['EventRegistrationsSubSection'];
};

export const CheckoutConfirmationEventRegistrations = memo<Props>(({ model }) => {
  const tHelper = useTHelper('checkout.confirmation.eventRegistrations');

  return (
    <>
      <h2 className="section-header">{model.SectionHeader}</h2>
      {model.Items.map((item) => (
        <CheckoutConfirmationTableLayout
          tHead={
            <tr>
              <th className="left">{item.FirstAndLastName}</th>
              <th className="right">{tHelper('information')}</th>
            </tr>
          }
          key={`${item.FirstAndLastName}${item.Amount}${item.Quantity}`}
        >
          <tr>
            <td className="left">{model.TicketsTerminology.Singular}</td>
            <td className="right">{item.ItemTitle}</td>
          </tr>
          <tr>
            <td className="left">{tHelper('id', { terminology: model.TicketsTerminology.Singular || '' })}</td>
            <td className="right">{item.CampaignRegistrationId}</td>
          </tr>
          <tr>
            <td className="left">{tHelper('price')}</td>
            <td className="right">
              {item.Amount > 0 ? commonFormatCurrencyWithType(item.Amount, model.CurrencyType) : tHelper('free')}
            </td>
          </tr>
          {item.CustomFields.map((field) => (
            <tr key={field.Name}>
              <td className="left">{field.Name}</td>
              <td className="right">{field.Value}</td>
            </tr>
          ))}
          {item.InvitationLink && (
            <tr>
              <td className="left">{tHelper('invitationLinkTitle')}</td>
              <td className="right">
                <UiOuterLink className="link-hoverable" href={item.InvitationLink}>
                  {item.InvitationLink}
                </UiOuterLink>
              </td>
            </tr>
          )}
        </CheckoutConfirmationTableLayout>
      ))}
    </>
  );
});
